<template>
    <div>
        <div class="grid relative overflow-hidden">
            <Filters />
            <Collapse :show="store.showMonthNavigation" :duration="200" easing="ease-in-out">
                <MonthNav v-model="month" />
            </Collapse>
            <Grid :items="store.items" />
            <MonthNav v-if="store.showMonthNavigation" v-model="month" :show-title="false" class="border-t border-grey -mt-[1px]" />
        </div>
    </div>
</template>

<script setup>
import { storeToRefs } from "pinia";
import { useFeedStore } from "@facet/utils/store.js";
import Filters from "@facet/components/Filters.vue";
// import Filterbar from "@facet/components/Filterbar.vue";
import Grid from "@facet/components/Grid.vue";
import Collapse from "@facet/global/Collapse.vue";
import MonthNav from "@facet/components/MonthNav.vue";

const store = useFeedStore();
const { month } = storeToRefs(store);
</script>
